import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SeoService } from '../../seo.services';

@Component({
  selector: 'app-referencias',
  templateUrl: './referencias.component.html',
  styleUrls: []
})
export class ReferenciasComponent implements OnInit {

  constructor(private title: Title, private seo: SeoService) { }

  ngOnInit() {
  	let t:string ="Referencias dentro del sitio | Sinuberase";
  	this.title.setTitle(t);

  	this.seo.generateTags({
  		title:"Referencias dentro del sitio | Sinuberase",
  		description: "Lista completa de referencias a estudios clínicos, artículos o datos relevantes utilizados en el contenido del sitio web de Sinuberase",
  		slug: "Referencias"
  	})

  	this.seo.closeMenu();
  }

}
